import { render, staticRenderFns } from "./SmartnewsConversionApiHistoryList.vue?vue&type=template&id=09848bdc&scoped=true"
import script from "./SmartnewsConversionApiHistoryList.vue?vue&type=script&lang=js"
export * from "./SmartnewsConversionApiHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09848bdc",
  null
  
)

export default component.exports